import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-774fb9ad"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "gameDetail"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 暂无数据 ");

const _hoisted_3 = {
  class: "panel"
};
const _hoisted_4 = {
  class: "panel-title"
};
const _hoisted_5 = {
  class: "panel-body"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#E6A23C"
  }
}, "会员", -1));

const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 0,
  class: "redcolor"
};
const _hoisted_10 = {
  key: 1
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_15 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.list.length == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_2], 64)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      key: i
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h2", null, _toDisplayString(item.gname), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
      data: item.bet.bet,
      border: "",
      size: "small",
      "highlight-current-row": "",
      "max-height": "300",
      "header-cell-class-name": "table-header-cell",
      "header-row-class-name": "table-header-row",
      "show-summary": "",
      "summary-method": $options.baobiao_sum
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "username",
        label: "代理",
        align: "center"
      }, {
        default: _withCtx(scope => [scope.row.group_id === '0' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("span", null, _toDisplayString(scope.row.username), 1), _hoisted_6], 64)) : (_openBlock(), _createBlock(_component_el_link, {
          key: 1,
          type: "success",
          onClick: $event => _ctx.$emit('search_sub', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.username), 1)]),
          _: 2
        }, 1032, ["onClick"]))]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "real_name",
        label: "名称",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "bet_count",
        label: "笔数",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "sum_bet",
        label: "总投注额",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "balance",
        label: "有效金额",
        align: "center"
      }, {
        default: _withCtx(scope => [scope.row.balance != '0' ? (_openBlock(), _createBlock(_component_el_link, {
          key: 0,
          type: "success",
          onClick: $event => _ctx.$emit('search_detail', scope.row, item.gid)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.balance), 1)]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.balance), 1))]),
        _: 2
      }, 1024), _createVNode(_component_el_table_column, {
        prop: "bonus",
        label: "会员输赢",
        align: "center"
      }, {
        default: _withCtx(scope => [$props.form.settle_state != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [scope.row.bonus - scope.row.balance < 0 ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString((scope.row.bonus - scope.row.balance).toFixed(0)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString((scope.row.bonus - scope.row.balance).toFixed(0)), 1))])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "receive_subline",
        label: "应收下线",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
          placement: "top"
        }, {
          content: _withCtx(() => [_createTextVNode(" 输赢：" + _toDisplayString((scope.row.balance - scope.row.bonus).toFixed(0)) + " ", 1), _hoisted_11, _createTextVNode(" 退水：" + _toDisplayString(scope.row.rebate), 1)]),
          default: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass(scope.row.receive_subline < 0 ? 'redcolor' : '')
          }, _toDisplayString(scope.row.receive_subline), 3)]),
          _: 2
        }, 1024)])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "occupy_self",
        label: "占成",
        align: "center",
        width: "40"
      }), _createVNode(_component_el_table_column, {
        prop: "occu_balance",
        label: "实占注额",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "bonus",
        label: "占货比",
        align: "center",
        width: "47"
      }, {
        default: _withCtx(scope => [item.bet.small.occu_balance == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "0")) : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString((scope.row.occu_balance / item.bet.small.occu_balance * 100).toFixed(0)), 1))]),
        _: 2
      }, 1024), _createVNode(_component_el_table_column, {
        prop: "occu_winlose",
        label: "实占输赢",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("div", null, [scope.row.group_id === '2' ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          placement: "top"
        }, {
          content: _withCtx(() => [_createTextVNode(" 输赢：" + _toDisplayString(scope.row.occu_winlose - scope.row.eran) + " ", 1), _hoisted_14, _createTextVNode(" 赚赔：" + _toDisplayString(scope.row.eran), 1)]),
          default: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass(scope.row.occu_winlose < 0 ? 'redcolor' : '')
          }, _toDisplayString(scope.row.occu_winlose), 3)]),
          _: 2
        }, 1024)) : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(scope.row.occu_winlose), 1))])]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "occu_rebate",
        label: "实占退水",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "earn_rebate",
        label: "赚取退水",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "real_result",
        label: "退水后结果",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", {
          class: _normalizeClass(scope.row.real_result < 0 ? 'redcolor' : '')
        }, _toDisplayString(scope.row.real_result), 3)]),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "cont_sup",
        label: "贡献上级",
        align: "center"
      }), _createVNode(_component_el_table_column, {
        prop: "receive_supline",
        label: "应付上级",
        align: "center"
      }, {
        default: _withCtx(scope => [_createElementVNode("span", {
          class: _normalizeClass(scope.row.receive_supline < 0 ? 'redcolor' : '')
        }, _toDisplayString(scope.row.receive_supline), 3)]),
        _: 1
      })]),
      _: 2
    }, 1032, ["data", "summary-method"])])])]);
  }), 128))]);
}